module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-2-bba1e5bc64d1fcc18e4f0a81d12f9020.svg";